module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "条件配置"
    }
  }, [_c('div', {
    staticClass: "fz-12 m-t-10"
  }, [_c('span', [_vm._v("*日期时间变量说明：Y代表年，M代表月，D代表天，H代表时，I代表分，S代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。\n        例：D+1代表明天，M+1代表下个月，H+1代表一个小时后， m+10代表十分钟后，s+30代表30秒后，不填即为当前时间。同时支持格式化时间变量格式：(Y+1)-(M)-19 00:(I+5):S")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("*同一个字段可能有多种情况，且如果是时间变量的话，有可能存在两个条件同时成立的情况，那么就按位置在前面的来显示")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "字段",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.field_id),
            expression: "scope.row.field_id"
          }],
          attrs: {
            "size": "small"
          },
          domProps: {
            "value": (scope.row.field_id)
          },
          on: {
            "input": function($event) {
              scope.row.field_id = $event
            }
          }
        }, _vm._l((_vm.fields), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.title,
              "value": item.field_id
            }
          }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "逻辑",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.logic),
            expression: "scope.row.logic"
          }],
          attrs: {
            "size": "small"
          },
          domProps: {
            "value": (scope.row.logic)
          },
          on: {
            "input": function($event) {
              scope.row.logic = $event
            }
          }
        }, _vm._l((_vm.logicOptions), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.label,
              "value": option.value
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "值类型",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.type),
            expression: "scope.row.type"
          }],
          attrs: {
            "size": "small"
          },
          domProps: {
            "value": (scope.row.type)
          },
          on: {
            "input": function($event) {
              scope.row.type = $event
            }
          }
        }, _vm._l((_vm.typeOptions), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.label,
              "value": option.value
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "值"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.value),
            expression: "scope.row.value"
          }],
          domProps: {
            "value": (scope.row.value)
          },
          on: {
            "input": function($event) {
              scope.row.value = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteConfig(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 block"
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.addConfig()
      }
    }
  }, [_vm._v("添加")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sure()
      }
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2425684f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/sheetConfig.vue
// module id = 1795
// module chunks = 2